import { render, staticRenderFns } from "./toURLlink.vue?vue&type=template&id=1778e07f&"
import script from "./toURLlink.vue?vue&type=script&lang=js&"
export * from "./toURLlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports